import {Box, Button, Stack, Typography} from '@mui/material';
import TextOptionWithRemove from '../../atoms/textOptionWithRemove/TextOptionWithRemove';
import {useCallback} from 'react';

export interface BondAnswerOptionListWithRemoveProps {
  options: string[];
  onOptionChange: (value: string[]) => void;
  title?: string;
}

/**
 *
 * @param options - The options to display
 * @param onOptionChange - The function to call when the option changes
 * @param onAddOption - The function to call when the option is added
 * @param onRemoveOption - The function to call when the option is removed
 * @returns
 */
export default function BondAnswerOptionListWithRemove({
  options,
  onOptionChange,
  title = 'Answer Options',
}: BondAnswerOptionListWithRemoveProps) {
  const handleAddOption = useCallback(() => {
    onOptionChange([...options, '']);
  }, [onOptionChange, options]);

  const handleRemoveOption = useCallback(
    (index: number) => {
      onOptionChange(options.filter((_, i) => i !== index));
    },
    [onOptionChange, options],
  );

  const handleOptionChange = useCallback(
    (index: number, value: string) => {
      onOptionChange(options.map((option, i) => (i === index ? value : option)));
    },
    [onOptionChange, options],
  );

  return (
    <Box data-testid="bond-answer-option-list-with-remove">
      <Typography variant="h6" sx={{color: '#1B263B', mb: 2}}>
        {title}
      </Typography>
      <Stack spacing={2}>
        {options.map((option, index) => (
          <TextOptionWithRemove
            // eslint-disable-next-line react/no-array-index-key
            key={`BondAnswerOptionListWithRemove-${index}`}
            index={index}
            value={option}
            onChange={handleOptionChange}
            onRemove={options.length > 2 ? handleRemoveOption : undefined}
            tooltipRender
          />
        ))}
        <Button variant="outlined" onClick={handleAddOption} sx={{alignSelf: 'flex-start'}}>
          Add Option
        </Button>
      </Stack>
    </Box>
  );
}
